import { z } from 'zod';

/**
 * События аналитики. Серверные пишет API/воркер (деньги, генерации — источник правды),
 * клиентские — мини-апп (экраны и клики). Тексты промптов, фото и реквизиты в события не попадают.
 */
export const SERVER_EVENTS = [
  'signup',
  'consent',
  'trend_view',
  'generation_created',
  'generation_succeeded',
  'generation_failed',
  'payment_created',
  'payment_paid',
  'duo_invite',
  'duo_accept',
  'partner_transfer',
  'partner_payout',
  'moderation_block',
] as const;

export const CLIENT_EVENTS = ['screen_view', 'trend_open', 'cta_click', 'share', 'paywall_view', 'create_tab'] as const;
export type ClientEvent = (typeof CLIENT_EVENTS)[number];

const propValue = z.union([z.string().max(64), z.number().finite(), z.boolean(), z.null()]);

export const clientEventsSchema = z.object({
  events: z
    .array(
      z.object({
        name: z.enum(CLIENT_EVENTS),
        props: z
          .record(z.string().regex(/^[a-z][a-z0-9_]{0,31}$/), propValue)
          .refine((p) => Object.keys(p).length <= 10, 'Не больше 10 полей')
          .default({}),
      }),
    )
    .min(1)
    .max(20),
});
export type ClientEventsRequest = z.input<typeof clientEventsSchema>;

/** Отчёты для админки → «Аналитика». */
export interface AnalyticsFunnelRow {
  /** Источник: bot / miniapp / ref (по партнёрке) / duo; или саб-айди. */
  key: string;
  started: number;
  consent: number;
  generated: number;
  paid: number;
  repeat: number;
  revenue: number;
}

export interface AnalyticsCohortRow {
  /** Неделя регистрации (понедельник, YYYY-MM-DD). */
  week: string;
  users: number;
  /** Доля вернувшихся (любое действие) на 1-й / 7-й / 30-й день или позже, %. null — для когорты ещё рано. */
  d1: number | null;
  d7: number | null;
  d30: number | null;
  /** Доля платящих, %. */
  paying: number;
}

export interface AnalyticsTrendRow {
  id: string;
  title: string;
  views: number;
  generations: number;
  /** Генерации / просмотры, %. */
  conversion: number;
  revenue: number;
}

export interface AnalyticsDayRow {
  day: string;
  revenue: number;
  costRub: number;
  margin: number;
  generations: number;
  newUsers: number;
}

export interface AnalyticsView {
  period: 7 | 30 | 90;
  by: 'source' | 'sub';
  funnel: AnalyticsFunnelRow[];
  cohorts: AnalyticsCohortRow[];
  trends: AnalyticsTrendRow[];
  days: AnalyticsDayRow[];
  screens: { name: string; views: number; users: number }[];
}
